import React from "react";

// Converted to Tailwind/React from https://elements-docs.fa-switch.com/components/spinner
// FadvSpinnerAnimation is a bespoke animation defined in tailwind.config.js
export const FadvSpinner = () => {
    return (
        <div className="text-8xl h-[100px] w-[100px]">
            <svg part="base" className="h-full w-full" role="status" aria-live="polite" aria-busy="true">
                <circle
                    className="stroke-neutral-400 origin-center stroke-2 fill-none"
                    r="45px"
                    cx="50px"
                    cy="50px"
                />
                <circle
                    className="stroke-accent-600 origin-center animate-FadvSpinnerAnimation stroke-2 fill-none"
                    r="45px"
                    cx="50px"
                    cy="50px"
                    strokeLinecap="round"
                />
            </svg>
        </div>
    );
};